import { StudyContentPageType, TotalCourse } from '@asset/enum/materialEnum';
import {
  AnswerType,
  SolvingStatus,
  SolvingResult,
  StudyStep,
  ProblemStatusType,
} from '@asset/enum/problemSolvingEnum';
import { RubricGradeOverallResult } from '@asset/enum/studyContentEnum';

export type PageType =
  | 'my-study-materials'
  | 'my-assignments'
  | 'my-tests'
  | 'my-wrong-tests'
  | 'my-level-tests'
  | 'my-study-resources';

export type Status = SolvingStatus | SolvingResult;

export type ProblemStatusDetailType = {
  id: number;
  studyStatusType: StudyStep;
  solvingResult: Status;
  elapsedTime: number;
  studiedAt: number;
  hasErrorReport: boolean;
  isErrorReportResolved: boolean;
  hasNotUnderstandReport: boolean;
  isBookmark: boolean;
  hasWarning: boolean;
  isDescriptionMission?: boolean;
  btnType?: 'todo' | Status;
  feedbackStatus?: boolean;
  problemStatusType: ProblemStatusType;
  rubricGradeOverallResult:
    | RubricGradeOverallResult.CORRECT
    | RubricGradeOverallResult.WRONG
    | null;
  existsFeedbackCanvas: boolean;
};

export interface UrlInfo {
  myStudyContentId?: number;
  pageType?: StudyContentPageType;
  pageId: number;
  studyStatusType?: StudyStep;
  problemStatusId?: number;
  problemStatusDetailId?: number;
  reportId?: number;
  previousPage?: 'problem-solving' | 'my-questions';
}

export interface StudyItem {
  sections: ItemInSection[][];
}

export interface ItemInSection {
  problemStatusId: number;
  mediaType: MediaType;
  mediaUrl?: string;
  solvingCanvas?: CanvasInfo;
  solvingFeedbackCanvas?: CanvasInfo;
  mediaContent?: { width?; height?; objects? };
  // mediaType == 'answerJson'일 경우
  answerType?: AnswerType;
}

export enum MediaType {
  IMG = 'img',
  TEXT = 'text', // 지문
  VIDEO = 'video',
  ANSWER_CANVAS = 'answerCanvas',
  DRAWING_NOTE = 'drawingNote',
  ANSWER_JSON = 'answerJson',
  TAB_MENU = 'tabMenu',
}

export const CANVAS_SECTION_MEDIA_TYPES = new Set([
  MediaType.IMG,
  MediaType.TEXT,
  MediaType.DRAWING_NOTE,
]);

export type CanvasInfo = {
  editable: boolean;
  json: object | null;
} | null;

export enum CanvasType {
  IMG = 'img',
  DRAWING_NOTE = 'drawingNote',
}
export enum LayoutType {
  SECTION_CONTENT = 'sectionContent',
  EMPTY_CONTENT = 'emptyContent',
}

export type ClassificationType =
  | 'chapter'
  | 'section'
  | 'subsection'
  | 'problemType'
  | 'index'
  | 'subIndex';

export type Classification = {
  chapterIdx?: number | null;
  chapterName?: string | null;
  sectionIdx?: number | null;
  sectionName?: string | null;
  subsectionIdx?: number | null;
  subsectionName?: string | null;
  problemTypeIdx?: number | null;
  problemTypeName?: string | null;
  indexNumber?: number | null;
  indexName?: string | null;
  division?: string | null;
  subIndexNumber?: string | null;
};

export type ClassificationTreeElement = {
  label: string;
  value: string;
  progressRate: number;
  name: string;
  children: Classification[];
  pageIds: number[];
};

export type AnswerDetailData = {
  pageId: number;
  problemStatusDetailId: number;
  layoutType?: LayoutType;
  studyItem?: StudyItem;
  studyItemDetail?: object;
  result?: object;
};

export interface RubricTrait {
  id: number;
  order: number;
  title: string;
  value?: string;
  description: string;
}

export type MaterialInfo = {
  course: TotalCourse;
  materialName: string;
  materialType: string;
  indexNameType: string;
  description: string;
};
